<template>
    <el-container class="main" style="background-color: #F4F2F3;">
      <!-- 公路 -->
        <el-header v-if="waterTransport==0">
            <!-- header -->
            <div class="header">
              <div class="header-tag">
                <div class="header-tag-title">建设里程</div>
                <div class="header-tag-content">
                  <img src="../../static/images/jx/建设里程.png" />
                  <div class="header-tag-content-data">{{headData.mileage}}</div>
                  <div class="header-tag-content-unit">公里</div>
                </div>
              </div>
              <div class="header-tag">
                <div class="header-tag-title">计划总投资</div>
                <div class="header-tag-content">
                  <img src="../../static/images/jx/计划总投资.png" />
                  <div class="header-tag-content-data">{{headData.budgetInvestment}}</div>
                  <div class="header-tag-content-unit">亿元</div>
                </div>
              </div>
              <div class="header-tag">
                <div class="header-tag-title">标段概况</div>
                <div class="header-tag-content">
                  <img src="../../static/images/jx/投标概况.png" />
                  <div>
                    <div class="header-tag-content-type1">
                      <div class="header-tag-content-type1-title">全线施工标</div>
                      <div class="header-tag-content-type1-num">{{headData.constructionSectNum}}</div>
                      <div class="header-tag-content-type1-unit">个</div>
                    </div>
                    <div class="header-tag-content-type1">
                      <div class="header-tag-content-type1-title">全线监理标</div>
                      <div class="header-tag-content-type1-num">{{headData.supervisorSectNum}}</div>
                      <div class="header-tag-content-type1-unit">个</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="header-tag">
                <div class="header-tag-title">技术标准</div>
                <div class="header-tag-content">
                  <img src="../../static/images/jx/技术标准.png" />
                  <div class="header-tag-content-title1">{{this.headData.lanesNumber}}</div>
                </div>
              </div>
              <div class="header-tag">
                <div class="header-tag-title">设计时速</div>
                <div class="header-tag-content">
                  <img src="../../static/images/jx/设计时速.png" />
                  <div class="header-tag-content-title1">车速</div>
                  <div class="header-tag-content-data2">{{this.headData.designSpeed}}</div>
                  <div class="header-tag-content-unit2">km/h</div>
                </div>
              </div>
            </div>
        </el-header>
      <!-- 水运 -->
        <el-main v-if="imgUrl||imgUrlArr.length>0">
            <!--img-->
            <div class="demo-image__lazy" style="background-color: #eee;height:100%;">
                    <el-carousel v-if="!imgUrl" style="height:100%">
                    <el-carousel-item v-for="(item,index) in imgUrlArr" :key="index" style="height:100%;width:100%">
                        <img style="height:100%;width:100%" :src="item"></img>
                    </el-carousel-item>
                    </el-carousel>
                <el-image v-if="!!imgUrl" :src="imgUrl" lazy>
                  <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                  </div>
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
            </div>
        </el-main>
        <!-- 公路 -->
         <!-- map -->
        <el-main class="amap-page-container" v-if="!imgUrl && waterTransport==0&&imgUrlArr.length==0">
            <el-amap vid="amapDemo" mapStyle="light" :zoom="zoom" :center="center" :features="['bg', 'road']" class="amap-demo">
            <!-- 曲线 -->
            <el-amap-bezier-curve
              v-for="(line,index) in lines"
              :key="index"
              :path="line.path"
              :stroke-color="line.strokeColor"
              :stroke-style="line.strokeStyle"
              :stroke-opacity="line.strokeOpacity"
              :stroke-weight="line.strokeWeight"
            ></el-amap-bezier-curve>

            <!-- 标记点 -->
            <el-amap-marker
              v-for="(item, index) in marks"
              :key="'mark'+ index"
              :position="item.lnglat"
              topWhenClick="true"
              :extData="item"
              :content="getMarkerContent(item, 30, 40,index)"
            ></el-amap-marker>

            <el-amap-marker
              v-for="(item, index) in nodes"
              :key="'node'+ index"
              :position="item.lnglat"
              topWhenClick="true"
              :extData="item"
              :content="getNoderContent(item, 30, 40,index)"
              :events="item.events"
            ></el-amap-marker>

            <el-amap-info-window
              :position="currentWindow.position"
              :content="currentWindow.content"
              :visible="currentWindow.visible"
              :events="currentWindow.events"
            ></el-amap-info-window>
          </el-amap>
          <div class="unit" v-if="$idmConfig.isShowDefaultItemData">
              <div class="unit-single">
                <div class="unit-single-bridge"></div>
                <span>隧道</span>
                <div style="margin-left:30px" class="unit-single-tunnel"></div>
                <span>桥梁</span>
              </div>
              <div class="unit-img">
                <img src="../img/06.png" />
                <span>施工进度</span>
                <img src="../img/07.png" />
                <span>关键节点</span>
              </div>
          </div>
        </el-main>
    </el-container>
</template>
<script>
import {getCategoryListAsync} from "../js/common.js"
import {dealDot} from '../js/common'
export default {
  data() {
    return {
      projectId: "",
      engId: "",
      headData: {
        constructionSectNum: "-",
        supervisorSectNum: "-",
        mileage: "-",
        budgetInvestment: "-",
        lanesNumber: "- -",
        designSpeed: "-"
      },
      zoom: 10,
      center: [104.53, 27.81],
      lines: [],
      marks: [],
      nodes: [],
      // 选择节点弹框
      currentWindow: {
        position: [0, 0],
        content: "",
        events: {},
        visible: false
      },
      bridgeId: "",
      tunnelId: "",
      PI : 3.14159265358979324,
      x_pi : 3.14159265358979324 * 3000.0 / 180.0,
      imgUrl: "",
      imgUrlArr:[],
      projectTypeList:[],
      waterTransport: 2,
    };
  },
  created(){
    this.projectId = JSON.parse(sessionStorage.getItem("projectInfo")).projectId;
    this.engId = JSON.parse(sessionStorage.getItem("projectInfo")).engId;
  },
  async mounted(){
    // console.log("created","执行了！");
    this.projectId = JSON.parse(
        sessionStorage.getItem("projectInfo")
    ).projectId;
    let projectType=JSON.parse(
        sessionStorage.getItem("projectInfo")
    ).projectType;
    this.projectInfo=await this.loadProjectData(this.projectId);
    if(this.projectInfo.constructionSectNum)
      this.headData.constructionSectNum = dealDot(this.projectInfo.constructionSectNum,0);

    if(this.projectInfo.supervisorSectNum)
      this.headData.supervisorSectNum = dealDot(this.projectInfo.supervisorSectNum,0);
    // console.log("项目信息",this.projectInfo);
    //判断水运
    if(projectType && projectType=='2'){
      this.initImg();
      //水运直接返回，不加载数据
      this.waterTransport=1;
      return;
    }
    this.waterTransport=0;

    this.initImg();
    this.loadDict();
    this.loadHeadData();
  },
  methods: {
      loadProjectData(projectId){
        return new Promise((resolve, reject) => {
          this.$axios
            .post("/api/project/projectInfo/getSingleContent",
              this.$qs.stringify({
                  projectId: projectId
              })
            ).then(response => {
              resolve((response.data.data||{}));
            })
            .catch(error => {
              reject(error);
              // this.$message.error("数据获取失败");
              console.log("error:" + error.toString());
            });
        });
      },
      initImg() {
        this.imgUrlArr=[]
        let data = !!this.engId ? this.engId : this.projectId
          this.$axios.get(
                "/api/fs/files/search?metaData.formId=" + data +
                "&metaData.fileType=HOME_MAP"
              )
              .then(res => {
                  if (res.data && res.data.length > 0) {
                    if(res.data.length==1){
                        let fileId = res.data[res.data.length - 1].id;
                        this.imgUrl = window.location.origin + "/api/fs/files/download/" + fileId;
                    }else{
                        res.data.forEach(i=>{
                            this.imgUrlArr.push(`${window.location.origin}/api/fs/files/download/${i.id}`)
                        })

                    }

                  }
              })
              .catch(error => {});
      },
    showAlert(lng, lat, title) {
      this.currentWindow.visible = false;
      this.$nextTick(() => {
        this.currentWindow = {
          position: [lng, lat],
          content: `<div style='font-weight: 450;'>
              <div >${title}</div>
              <div style='font-size: 13px;'>2-1#梁场以按节点投产</div>
              <div style='font-size: 13px;'>投产进度：69%</div>
              </div>
              `,
          visible: true
        };
        this.currentWindow.visible = true;
      });
    },
    getNoderContent(item, width, height, index, isRotate = false) {
      const bgRoate = isRotate ? "transform: rotate(45deg);" : "";
      const txRotate = isRotate ? "transform: rotate(-45deg);" : "";
      let backgroundColor =
        item.level === "A"
          ? "#FF8100"
          : item.level === "B"
          ? "#8D3ECD"
          : "#2DCD72";
      if (isRotate) {
        backgroundColor = "#0893FF";
      }

      let topOrbottom = index % 2 == 0 ? 20 : -110;

      let path =
        "data:image/png;base64,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";
      const content = `<div style="
                                      justify-content: center;
                                      align-items: center;
                                      height: ${width}px;
                                      width: ${height}px;
                                      border-radius: .05rem;
                                      ${bgRoate}
                                      font-family: Arial-BoldMT;
                                      font-size: 16px;
                                      color: #FFFFFF;
                                      background-color: transparent;margin-left:-5px">
                                      <div style="color: #4e4e4e;font-size: 14px;margin-left: -90px;width: 200px;text-align: center;"> ${item.title} </div>
                                      <img style="width:20px;height:20px;margin-left:5px" src="${path}"/>
                           </div>`;

      return content;
    },
    getMarkerContent(item, width, height, index, isRotate = false) {
      const bgRoate = isRotate ? "transform: rotate(45deg);" : "";
      const txRotate = isRotate ? "transform: rotate(-45deg);" : "";
      let backgroundColor = "#8D3ECD";
      if (isRotate) {
        backgroundColor = "#0893FF";
      }

      let topOrbottom = index % 2 == 0 ? 20 : -110;

      let path =
        "data:image/png;base64,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";
      const content = `<div style="
                                      justify-content: center;
                                      align-items: center;
                                      height: ${width}px;
                                      width: ${height}px;
                                      border-radius: .05rem;
                                      ${bgRoate}
                                      font-family: Arial-BoldMT;
                                      font-size: 16px;
                                      color: #FFFFFF;
                                      background-color: transparent;margin-left:-5px">

                                      <div style="color: #4e4e4e;font-size: 14px;margin-left: -90px;width: 200px;text-align: center;"> ${item.title} </div>
                                      <img style="width:20px;height:20px;margin-left:5px" src="${path}"/>
                           </div>
                           <div style="color: #fff;background: #5EB97E;margin-top: ${topOrbottom}px;width: 120px;height: 70px;margin-left: -40px;">
                           <div style="padding: 5px;font-size: 13px;font-weight: 450;">
                           <div>${item.title}</div>
                           <div>投产进度：69%</div>
                           <div>施工进度：75%</div>
                           </div>
                           </div>`;

      return content;
    },
    loadMapData() {
      this.$axios
        .post(
          "/api/dftdstore/api/de/record/list?entityName=GS_CIRCUIT_DIAGRAM_XY",
          {
            fields: { PROJECT_ID: this.projectId }
          }
        )
        .then(res => {
          var mapData = res.data.rows;

          // 删除异常数据
          for (var i = 0; i < mapData.length; i++) {
            if (parseFloat(mapData[i].fields.LONG_ITUDE) > 200 || !mapData[i].fields.LONG_ITUDE) {
              mapData.splice(i, 1);
            } else {
              let point = this.gcj_encrypt(parseFloat(mapData[i].fields.LAT_ITUDE), parseFloat(mapData[i].fields.LONG_ITUDE))
              mapData[i].fields.LONG_ITUDE = point.lon
              mapData[i].fields.LAT_ITUDE = point.lat
            }
          }

          var path = []; //普通线路
          let nodes = []; //控制性工程 - 点
          let marks = []; //形象进度 - 点
          let j = 1; //控制性工程 - 点 - Title
          let k = 1; //形象进度 - 点 - Title
          var bridgePath = [];
          var tunnelPath = [];
          var bridgeLines = [];
          var tunnelLines = [];

          var maxLon = 0
          var minLon = 200
          var maxLat = 0
          var minLat = 100

          for (var i = 0; i < mapData.length; i++) {
            if (mapData[i].fields.LONG_ITUDE > maxLon) {
              maxLon = mapData[i].fields.LONG_ITUDE
            }
            if (mapData[i].fields.LAT_ITUDE > maxLat) {
              maxLat = mapData[i].fields.LAT_ITUDE
            }
            if (mapData[i].fields.LONG_ITUDE < minLon) {
              minLon = mapData[i].fields.LONG_ITUDE
            }
            if (mapData[i].fields.LAT_ITUDE < minLat) {
              minLat = mapData[i].fields.LAT_ITUDE
            }

            if (i === 0)
            {
              //处理曲线数据 -- 起点
              let startPoint = [
                parseFloat(mapData[0].fields.LONG_ITUDE),
                parseFloat(mapData[0].fields.LAT_ITUDE)
              ]
              path.push(startPoint);
            } else if (i === (mapData.length - 1))
            {
              //处理曲线数据 -- 路线
              let line = [
                parseFloat(mapData[i - 1].fields.LONG_ITUDE),
                parseFloat(mapData[i - 1].fields.LAT_ITUDE),
                parseFloat(mapData[i].fields.LONG_ITUDE),
                parseFloat(mapData[i].fields.LAT_ITUDE)
              ]
              path.push(line)
              this.lines.push({
                path: path,
                strokeDasharray: [10, 10],
                strokeColor: "#43BCFB", //线颜色
                strokeOpacity: 1, //线透明度
                strokeWeight: 6, //线宽
                strokeStyle: "solid" //线样式
              })
            } else
              {
              //处理曲线数据 -- 路线
              let line = [
                parseFloat(mapData[i - 1].fields.LONG_ITUDE),
                parseFloat(mapData[i - 1].fields.LAT_ITUDE),
                parseFloat(mapData[i].fields.LONG_ITUDE),
                parseFloat(mapData[i].fields.LAT_ITUDE)
              ]
              let distance = this.getDistance(mapData[i - 1].fields.LAT_ITUDE, mapData[i - 1].fields.LONG_ITUDE, mapData[i].fields.LAT_ITUDE, mapData[i].fields.LONG_ITUDE)
              if (distance < 600) {
                path.push(line)
              } else {
                // console.log(distance)
                this.lines.push({
                  path: path,
                  strokeDasharray: [10, 10],
                  strokeColor: "#43BCFB", //线颜色
                  strokeOpacity: 1, //线透明度
                  strokeWeight: 6, //线宽
                  strokeStyle: "solid" //线样式
                })
                path = []
                let startPoint = [
                  parseFloat(mapData[i].fields.LONG_ITUDE),
                  parseFloat(mapData[i].fields.LAT_ITUDE)
                ]
                path.push(startPoint);
              }
            }

            if (i !== 0 && mapData[i].fields.ENGINEERING_TYPE === this.bridgeId && mapData[i - 1].fields.ENGINEERING_TYPE === this.bridgeId)
            {
              if (bridgePath.length === 0) {
                let startPoint = [
                  parseFloat(mapData[i].fields.LONG_ITUDE),
                  parseFloat(mapData[i].fields.LAT_ITUDE)
                ];
                bridgePath.push(startPoint);
              } else {
                let line = [
                  parseFloat(mapData[i - 1].fields.LONG_ITUDE),
                  parseFloat(mapData[i - 1].fields.LAT_ITUDE),
                  parseFloat(mapData[i].fields.LONG_ITUDE),
                  parseFloat(mapData[i].fields.LAT_ITUDE)
                ]
                let distance = this.getDistance(mapData[i - 1].fields.LAT_ITUDE, mapData[i - 1].fields.LONG_ITUDE, mapData[i].fields.LAT_ITUDE, mapData[i].fields.LONG_ITUDE)

                if (distance < 600) {
                  bridgePath.push(line)
                } else {
                  bridgeLines.push(bridgePath)
                  bridgePath = []
                  let startPoint = [
                    parseFloat(mapData[i].fields.LONG_ITUDE),
                    parseFloat(mapData[i].fields.LAT_ITUDE)
                  ]
                  bridgePath.push(startPoint);
                }
              }
            } else if (i !== 0 && mapData[i].fields.ENGINEERING_TYPE === this.tunnelId && mapData[i - 1].fields.ENGINEERING_TYPE === this.tunnelId)
            {
              if (tunnelPath.length === 0) {
                let startPoint = [
                  parseFloat(mapData[i].fields.LONG_ITUDE),
                  parseFloat(mapData[i].fields.LAT_ITUDE)
                ];
                tunnelPath.push(startPoint);
              } else {
                let line = [
                  parseFloat(mapData[i - 1].fields.LONG_ITUDE),
                  parseFloat(mapData[i - 1].fields.LAT_ITUDE),
                  parseFloat(mapData[i].fields.LONG_ITUDE),
                  parseFloat(mapData[i].fields.LAT_ITUDE)
                ]
                let distance = this.getDistance(mapData[i - 1].fields.LAT_ITUDE, mapData[i - 1].fields.LONG_ITUDE, mapData[i].fields.LAT_ITUDE, mapData[i].fields.LONG_ITUDE)

                if (distance < 600) {
                  tunnelPath.push(line)
                } else {
                  tunnelLines.push(tunnelPath)
                  tunnelPath = []
                  let startPoint = [
                    parseFloat(mapData[i].fields.LONG_ITUDE),
                    parseFloat(mapData[i].fields.LAT_ITUDE)
                  ]
                  tunnelPath.push(startPoint);
                }
              }
            }

            //处理控制性工程数据 -- 点
            if (mapData[i].fields.CONTROL_ENGINEERING === '是') {
              // console.log(mapData[i].fields)
              //Mark点
              mapData[i].fields.index = i
              mapData[i].fields.title = 'K' + j;
              mapData[i].fields.lnglat = [
                parseFloat(mapData[i].fields.LONG_ITUDE),
                parseFloat(mapData[i].fields.LAT_ITUDE)
              ];
              //Mark点击事件
              mapData[i].fields.events = {
                click: e => {
                  this.showAlert(
                    e.lnglat.lng,
                    e.lnglat.lat,
                    e.target.B.extData.title
                  );
                }
              };
              nodes.push(mapData[i].fields);

              if (nodes.length > 1) {
                //Node点
                // let mark = mapData[parseInt((nodes[nodes.length].index + nodes[nodes.length - 1].index) / 2)].fields;
                // mark.lnglat = [
                //   parseFloat(mark.LONG_ITUDE),
                //   parseFloat(mark.LAT_ITUDE)
                // ];
                // mark.title = k + "标段";
                // k++;
                // marks.push(mark);
              }
              j++
            }
          }

          // console.log(maxLon)
          // console.log(minLon)
          // console.log(maxLat)
          // console.log(minLat)
          this.center = [
            parseFloat((maxLon + minLon) / 2),
            parseFloat((maxLat + minLat) / 2)
          ];

          // console.log(this.lines.length)

          for (var i = 0; i < bridgeLines.length; i++) {
              this.lines.push({
                path: bridgeLines[i],
                strokeDasharray: [10, 10],
                strokeColor: "#F17E1C", //线颜色
                strokeOpacity: 1, //线透明度
                strokeWeight: 7, //线宽
                strokeStyle: "solid" //线样式
              });
          }
          for (var i = 0; i < tunnelLines.length; i++) {
            this.lines.push({
              path: tunnelLines[i],
              strokeDasharray: [10, 10],
              strokeColor: "#A40000", //线颜色
              strokeOpacity: 1, //线透明度
              strokeWeight: 7, //线宽
              strokeStyle: "solid" //线样式
            });
          }

          // for (var i = 0; i < mapData.length; i++) {
          //   if (i == 0) {
          //     //处理曲线数据 -- 起点
          //     let startPoint = [
          //       parseFloat(mapData[0].fields.LONG_ITUDE),
          //       parseFloat(mapData[0].fields.LAT_ITUDE)
          //     ];
          //     path.push(startPoint);
          //   } else {
          //     if (i % 2 == 0) {
          //       //处理曲线数据 -- 路线
          //       let line = [
          //         parseFloat(mapData[i - 1].fields.LONG_ITUDE),
          //         parseFloat(mapData[i - 1].fields.LAT_ITUDE),
          //         parseFloat(mapData[i].fields.LONG_ITUDE),
          //         parseFloat(mapData[i].fields.LAT_ITUDE)
          //       ];
          //       console.log(this.getDistance(mapData[i - 1].fields.LAT_ITUDE, mapData[i - 1].fields.LONG_ITUDE, mapData[i].fields.LAT_ITUDE, mapData[i].fields.LONG_ITUDE))
          //       path.push(line);
          //
          //       if (
          //         mapData[i].fields.ENGINEERING_TYPE === this.bridgeId ||
          //         mapData[i - 1].fields.ENGINEERING_TYPE === this.bridgeId
          //       ) {
          //         if (bridgePath.length == 0) {
          //           //处理桥梁曲线数据 -- 起点
          //           bridgePath.push([
          //             path[path.length - 1][2],
          //             path[path.length - 1][3]
          //           ]);
          //         }
          //         let bridge = [
          //           parseFloat(mapData[i - 1].fields.LONG_ITUDE),
          //           parseFloat(mapData[i - 1].fields.LAT_ITUDE),
          //           parseFloat(mapData[i].fields.LONG_ITUDE),
          //           parseFloat(mapData[i].fields.LAT_ITUDE)
          //         ];
          //         bridgePath.push(bridge);
          //       } else if (
          //         mapData[i].fields.ENGINEERING_TYPE === this.tunnelId ||
          //         mapData[i - 1].fields.ENGINEERING_TYPE === this.tunnelId
          //       ) {
          //         if (tunnelPath.length == 0) {
          //           //处理桥梁曲线数据 -- 起点
          //           tunnelPath.push([
          //             path[path.length - 1][2],
          //             path[path.length - 1][3]
          //           ]);
          //         }
          //         let tunnel = [
          //           parseFloat(mapData[i - 1].fields.LONG_ITUDE),
          //           parseFloat(mapData[i - 1].fields.LAT_ITUDE),
          //           parseFloat(mapData[i].fields.LONG_ITUDE),
          //           parseFloat(mapData[i].fields.LAT_ITUDE)
          //         ];
          //         tunnelPath.push(tunnel);
          //       }
          //     }
          //   }
          //   //处理控制性工程数据 -- 点
          //   if (mapData[i].fields.CONTROL_ENGINEERING === "是") {
          //     //Mark点
          //     mapData[i].fields.title = "K" + j;
          //     mapData[i].fields.lnglat = [
          //       parseFloat(mapData[i].fields.LONG_ITUDE),
          //       parseFloat(mapData[i].fields.LAT_ITUDE)
          //     ];
          //     //Mark点击事件
          //     mapData[i].fields.events = {
          //       click: e => {
          //         this.showAlert(
          //           e.lnglat.lng,
          //           e.lnglat.lat,
          //           e.target.B.extData.title
          //         );
          //       }
          //     };
          //     nodes.push(mapData[i].fields);
          //
          //     if (i / 2 != 0) {
          //       //Node点
          //       let mark = mapData[parseInt(i / 2 - 1)].fields;
          //       mark.lnglat = [
          //         parseFloat(mark.LONG_ITUDE),
          //         parseFloat(mark.LAT_ITUDE)
          //       ];
          //       mark.title = k + "标段";
          //       k++;
          //       marks.push(mark);
          //     }
          //     j++;
          //   }
          // }

          // this.lines.push({
          //   path: path,
          //   strokeDasharray: [10, 10],
          //   strokeColor: "#43BCFB", //线颜色
          //   strokeOpacity: 1, //线透明度
          //   strokeWeight: 16, //线宽
          //   strokeStyle: "solid" //线样式
          // });
          // if (bridgePath.length > 0) {
          //   this.lines.push({
          //     path: bridgePath,
          //     strokeDasharray: [10, 10],
          //     strokeColor: "#F17E1C", //线颜色
          //     strokeOpacity: 1, //线透明度
          //     strokeWeight: 16, //线宽
          //     strokeStyle: "solid" //线样式
          //   });
          // }
          // if (tunnelPath.length > 0) {
          //   this.lines.push({
          //     path: tunnelPath,
          //     strokeDasharray: [10, 10],
          //     strokeColor: "#A40000", //线颜色
          //     strokeOpacity: 1, //线透明度
          //     strokeWeight: 16, //线宽
          //     strokeStyle: "solid" //线样式
          //   });
          // }

          this.nodes = nodes;
          this.marks = marks;
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadHeadData() {
      this.$axios
        .post(
          "/api/project/projectInfo/getSingleContent",
          this.$qs.stringify({
            projectId: this.projectId
          })
        )
        .then(res => {
          if (res.data.succeed) {
            this.headData.mileage = res.data.data.mileage
              ? dealDot(res.data.data.mileage,2)
              : "-";
            this.headData.budgetInvestment = res.data.data.budgetInvestment
              ? dealDot(res.data.data.budgetInvestment,2)
              : "-";

            if (res.data.data.lanesNumber) {
              this.$axios
                .post(
                  "/api/category/getCategoryList/key?value=" + "projectLanes"
                )
                .then(res1 => {
                    // console.log(res1)
                  let enumData = res1.data.data;
                  let code = res.data.data.lanesNumber;
                  let name='';
                  enumData.some((val)=>{
                    if(val.code==res.data.data.lanesNumber){
                      name=val.name;
                    }
                  })
                  // let item=enumData.find(
                  //   element => element.code == res.data.data.lanesNumber
                  // ).code;
                  // console.log('aaaaaaaa',item)
                  this.headData.lanesNumber = name;
                  // switch (code) {
                  //   case "1":
                  //     this.headData.lanesNumber = "四";
                  //     break;
                  //   case "2":
                  //     this.headData.lanesNumber = "六";
                  //     break;
                  //   case "3":
                  //     this.headData.lanesNumber = "六（四）";
                  //     break;
                  //   case "4":
                  //     this.headData.lanesNumber = "二";
                  //      break;
                  //   case "5":
                  //     this.headData.lanesNumber = "八";
                  //      break;
                  //   default:
                  //     this.headData.lanesNumber = "- -";
                  //     break;
                  // }
                })
                .catch(error => {
                  console.log(error);
                });
            }
          }
        })
        .catch(error => {
          console.log(error);
        });

      // 弃用的标段数接口
      // this.$axios
      //   .post(
      //     "/api/project/sectionInfo/getAllContentList?page=1&rows=100&" +
      //       "prjid=" +
      //       this.projectId +
      //       "&sectionMajors=3,4,5,6,7,8,9",
      //     {
      //       projectId: this.projectId
      //     }
      //   )
      //   .then(res => {
      //     this.headData.constructionCount = res.data.total.toString();
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });

      // this.$axios
      //   .post(
      //     "/api/project/sectionInfo/getAllContentList?page=1&rows=100&" +
      //       "prjid=" +
      //       this.projectId +
      //       "&sectionMajors=0",
      //     {
      //       projectId: this.projectId
      //     }
      //   )
      //   .then(res => {
      //     this.headData.supervisionCount = res.data.total.toString();
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });

      //获取设计车速
      this.$axios
        .post("/api/project/projectLineDivision/getAllContentList",
          this.$qs.stringify({projectId: this.projectId})
        )
        .then(res => {
          if (res.data.rows.length > 0) {
            this.$axios
              .post("/api/project/projectAmount/getAllContentList",  this.$qs.stringify({
                lineDivisionId: res.data.rows[0].lineDivisionId
              }))
              .then(res => {
                res.data.rows.map(item => {
                  if (item.statItemName == "设计速度") {
                    this.headData.designSpeed = item.designValue
                      ? dealDot(item.designValue,0)
                      : "-";
                  }
                });
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadDict() {
      this.$axios
        .get("/api/category/getCategoryList/key?value=sectionType")
        .then(res => {
          res.data.data.map(item => {
            if (item.code === "section_type_4") {
              //桥梁工程
              this.bridgeId = item.id;
            } else if (item.code === "section_type_6") {
              //隧道工程
              this.tunnelId = item.id;
            }
          });
          this.loadMapData();
        })
        .catch(error => {
          console.log(error);
        });
    },
    //计算两个经纬度距离
    getRad(d){
    var PI = Math.PI;
    return d*PI/180.0;
  },
    getDistance(lat1,lng1,lat2,lng2) {
    var f = this.getRad((lat1 + lat2)/2);
    var g = this.getRad((lat1 - lat2)/2);
    var l = this.getRad((lng1 - lng2)/2);
    var sg = Math.sin(g);
    var sl = Math.sin(l);
    var sf = Math.sin(f);
    var s,c,w,r,d,h1,h2;
    var a = 6378137.0;//The Radius of eath in meter.
    var fl = 1/298.257;
    sg = sg*sg;
    sl = sl*sl;
    sf = sf*sf;
    s = sg*(1-sl) + (1-sf)*sl;
    c = (1-sg)*(1-sl) + sf*sl;
    w = Math.atan(Math.sqrt(s/c));
    r = Math.sqrt(s*c)/w;
    d = 2*w*a;
    h1 = (3*r -1)/2/c;
    h2 = (3*r +1)/2/s;
    s = d*(1 + fl*(h1*sf*(1-sg) - h2*(1-sf)*sg));
    s = s;
    s = s.toFixed(2);//指定小数点后的位数。
    return s;
  },
    //WGS-84 to GCJ-02
    gcj_encrypt(wgsLat, wgsLon) {
      if (this.outOfChina(wgsLat, wgsLon))
        return {lat: wgsLat, lon: wgsLon};

      var d = this.delta(wgsLat, wgsLon);
      return {lat: wgsLat + d.lat,lon: wgsLon + d.lon};
    },
    delta(lat, lon) {
      // Krasovsky 1940
      //
      // a = 6378245.0, 1/f = 298.3
      // b = a * (1 - f)
      // ee = (a^2 - b^2) / a^2;
      var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
      var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
      var dLat = this.transformLat(lon - 105.0, lat - 35.0);
      var dLon = this.transformLon(lon - 105.0, lat - 35.0);
      var radLat = lat / 180.0 * this.PI;
      var magic = Math.sin(radLat);
      magic = 1 - ee * magic * magic;
      var sqrtMagic = Math.sqrt(magic);
      dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI);
      dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI);
      return {lat: dLat, lon: dLon};
    },
    outOfChina(lat, lon) {
      if (lon < 72.004 || lon > 137.8347)
        return true;
      if (lat < 0.8293 || lat > 55.8271)
        return true;
      return false;
    },
    transformLat(x, y) {
      var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
      ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
      ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
      return ret;
    },
    transformLon(x, y) {
      var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
      ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
      ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
      return ret;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
/deep/.amap-info-content {
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
}
/deep/ .amap-info-sharp {
  border-top: 8px solid rgba(0, 0, 0, 0.7);
}

</style>
<style lang="less" scoped>
  .main {
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
    padding: 10px 20px 0;
    overflow: hidden;
    box-sizing: border-box;
    .el-header {
      height: auto!important;
    }
    .el-image{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-icon-picture-outline {
        font-size: 4em;
        color: #ddd;
      }
    }
    .amap-page-container {
      overflow: hidden;
    }
  }
.unit {
  position: relative;
  left: 20px;
  top: -120px;
  background: #fff;
  width: 200px;
  height: 80px;
  border: 1px solid #acdff9;
  color: #44ee4e;
  font-size: 12px;
  &-img {
    display: flex;
    img {
      width: 13px;
      height: 13px;
      margin: 2px 14px;
    }
    span {
      margin-left: 0px;
    }
  }
  &-single {
    display: flex;
    &-bridge {
      width: 10px;
      height: 10px;
      background: #a40000;
      margin: 20px 10px 15px 15px;
    }
    &-tunnel {
      width: 10px;
      height: 10px;
      background: #f17e1c;
      margin: 20px 14px 15px 25px;
    }
    span {
      margin-left: 6px;
      margin-top: 16px;
      width: 33px;
    }
  }
}
/*.amap-page-container {*/
/*  height: calc(100vh - 90px);*/
/*  margin-top: 10px;*/
/*}*/

.header {
  display: flex;
  justify-content: space-between;
  &-tag {
    padding: 5px 10px;
    box-sizing: border-box;
    background-color: #fff;
    width: 18%;
    &-title {
      font-size: 12px;
      color: #ACB1B6;
      font-weight: 500;
      border-bottom: 1px solid #e8e8e8;
      padding-bottom: 4px;
    }
    &-content {
      display: flex;
      color: #4e4e4e;
      align-items: center;
      height: 60px;
      img {
        width: 40px;
        height: 40px;
        // height: 35px;
      }
      &-data {
        font-size: 25px;
        font-weight: 600;
        margin-left: 10px;
      }
      &-unit {
        margin-left: 3px;
        margin-top: 5px;
        font-size: 12px;
        font-weight: bold;
        align-items: flex-end;
      }
      &-data1 {
        margin: -2px 5px 0 5px;
        font-size: 17px;
        font-weight: bold;
      }
      &-data2 {
        margin: 2px 5px 0 5px;
        font-size: 17px;
        font-weight: bold;
      }
      &-title1 {
        margin-left: 10px;
        font-size: 12px;
        font-weight: bold;
      }
      &-unit1 {
        font-size: 12px;
        font-weight: bold;
      }
      &-unit2 {
        font-size: 12px;
        font-weight: bold;
      }
      &-type1 {
        display: flex;
        margin: 10px 0 0 0;
        &-title {
          margin: 0 0 0 10px;
          font-size: 12px;
          font-weight: bold;
        }
        &-num {
          margin: -1px 5px 0px 8px;
          font-size: 15px;
          font-weight: bold;
        }
        &-unit {
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
  }
}
.demo-image__lazy{
    /deep/.el-carousel__container{
        height: 100%;

    }

}
</style>



// WEBPACK FOOTER //
// src/views/defaultImg.vue